import axios from "axios";
import debounce from "lodash/debounce";
import BackgroundVideo from "./BackgroundVideo";

export class RecipeArchive {
  constructor() {
    this.recipeArchiveEl = document.getElementById("recipe-archive");
    this.recipeActiveFiltersEl = document.getElementById(
      "recipe-active-filters"
    );
    this.noRecipesEl = document.getElementById("no-recipes-found");
    this.bannerEl = document.getElementById("recipe-banner");
    this.loaderEl = this.recipeArchiveEl.querySelector(".sf-loader");
    this.ctaEl = null;
    this.recipes = [];
    this.recipeCardEls = [];
    this.recipesContainerEl = document.getElementById("recipe-results");
    this.ctaContainer = document.getElementById("section-recipe-cta");
    this.filterRecipeArchiveButton = document.getElementById(
      "filter-recipe-archive"
    );
    this.advancedFilterToggle = document.querySelector("a.advanced-filter-toggle");
    
    this.loadMoreButton = document.getElementById("load-more-recipes");
    this.recipeBannerEl = document.getElementById("recipe-banner");
    this.filters = [];
    this.activeFilterTags = [];
    this.searchInput = document.querySelector(
      "#recipe-text-search input.search-form-input"
    );
    this.searchQuery = null;
    this.totalCount = 0;
    this.start = 0;
    this.baseCount = 9;
    this.ipp = 27;
    this.currentBanner = document.querySelector(
      "#recipe-banner .recipes-banner__banner"
    );
    this.newBanner = null;
    this.newBannerFadeInDuration = 1000;
    this.backgroundVideo = null;
    this.params = {};
    this.page = 1;

    this.init();
  }

  init() {
    this.setBannerHeight();
    this.setupFilters();
    this.setupSearch();

    // When page initializes, check if the current url has filtering enabled
    const locationHref = window.location.href;
    if (locationHref.indexOf("?") > -1) {
      // Get the query string
      const query_string = locationHref.split("?").pop();
      // Spilt it.
      const paramStringArray = query_string.split("&");
      // For each variable turn it into an array based on commas
      paramStringArray.forEach((string) => {
        const split = string.split("=");
        if (split[0]) this.params[split[0]] = split[1].split(",");
      });

      // Black Airplane's script just lumps all filters together, so build a new array that does that excluding the ingredients
      // TODO - Make this meaningful.
      let allValues = [];
      for (const key in this.params) {
        if (key != "ingredients") {
          allValues = allValues.concat(this.params[key]);
        }
      }
      this.filters.forEach((filter) => {
        if (allValues.find((listedValue) => listedValue === filter.slug)) {
          this.toggleFilter(filter.termId, true);
        }
      });

      // If there is a search query, set it
      if (this.params.ingredients) {
        this.searchInput.value = window.decodeURIComponent(
          this.params.ingredients
        );
        this.searchQuery = window.decodeURIComponent(this.params.ingredients);
      }

      // If there is a start position, set it
      if (this.params.page) {
        this.page = parseInt(this.params.page);
      }
    }

    // Listeners
    this.filterRecipeArchiveButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.getRecipes();
    });
    this.loadMoreButton.addEventListener("click", () => {
      this.loadMore();
    });
    this.advancedFilterToggle.addEventListener("click", this.toggleAdvancedFilters.bind(this));
    // Finally, get the recipes
    this.getRecipes(true);
  }

  setupFilters() {
    document
      .querySelectorAll(".archive-filter")
      .forEach((recipeArchiveFilter) => {
        // <div data-some-long-property="test">
        const taxonomy = recipeArchiveFilter.dataset.taxonomy;
        const termId = recipeArchiveFilter.dataset.termId;
        const label = recipeArchiveFilter.dataset.label;
        const slug = recipeArchiveFilter.dataset.slug;
        const taxonomyLabel = recipeArchiveFilter.dataset.taxonomyLabel;

        // if (taxonomy !== "campaign") {
          recipeArchiveFilter.addEventListener("click", () => {
            this.toggleFilter(termId);
          });

          this.filters.push({
            el: recipeArchiveFilter,
            taxonomy: taxonomy,
            termId: termId,
            selected: false,
            label: label,
            slug: slug,
            taxonomyLabel: taxonomyLabel,
          });
        // }
      });
  }

  // Update the URL with the current filters and search query
  updateUrl() {
    // Update the query string with the current filters
    const newQueryString = [];
    this.filters.forEach((filter) => {
      if (filter.selected) {
        newQueryString.push(`${filter.taxonomy}=${filter.slug}`);
      }
    });

    // Update the query string with the current search query
    if (this.searchQuery) {
      newQueryString.push(`ingredients=${this.searchQuery}`);
    }

    // Update the page position if not 1
    if (this.page > 1) {
      newQueryString.push(`page=${this.page}`);
    }

    // Update the url
    let newUrl = `${window.location.origin}${window.location.pathname}`;
    if (newQueryString.length > 0) newUrl += `?${newQueryString.join("&")}`;
    window.history.pushState({}, "", newUrl);
    // Trigger GA pageview for the new URL
    analytics.track.client("page_view", { page_title: document.title, page_location: newUrl }, ["googleAnalytics"]);

  }

  setupSearch() {
    const debounceSearch = debounce((e) => {
      this.start = 0;
      this.page = 1;
      this.searchQuery = e.target.value;
      this.getRecipes();
      // Update the url with the search query
      this.updateUrl();
      // Trigger GA event
      analytics.track.client("recipe_ingredient_search", { event_category: "search", search_term: this.searchQuery }, ["googleAnalytics"]);
    }, 350);

    if (this.searchInput)
      this.searchInput.addEventListener("input", debounceSearch);
  }

  loadMore() {
    if (this.start === 0) {
      this.start = this.baseCount;
    } else {
      this.start = this.start + this.ipp;
    }
    this.page++;

    this.getRecipes();
    this.updateUrl();
  }

  getRecipes(intialLoad = false) {
    this.loaderEl.classList.add("sf-loader--loading");

    if (this.start === 0) {
      this.recipesContainerEl.innerHTML = "";
    }

    const filterData = [];
    this.filters.forEach((filter) => {
      if (filter.selected) {
        filterData.push({
          taxonomy: filter.taxonomy,
          term_id: filter.termId,
        });
      }
    });

    // Build the post data
    const postVariables = {
      filters: filterData,
      offset: this.start,
      s: this.searchQuery,
      o: "ingredient",
    };
    // If this is the initial load, get recipes from 0
    if (intialLoad) {
      const totalPosts = this.baseCount + this.ipp * (this.page - 1);
      postVariables.total = totalPosts;
    }
    // Add headers to the options
    const postOptions = {
      headers: {
      },
    };

    // Make the request
    axios
      .post(
        window.sanderson_farms.resturl + "sanderson-farms/v2/recipes/",
        postVariables,
        postOptions
      )
      .then((response) => {
        this.bannerData = response.data.banner_data;
        this.totalCount = response.data.total_count;

        if (this.start === 0) {
          this.recipes = response.data.recipes;
          this.renderBanner();
        } else {
          this.recipes.push(...response.data.recipes);
        }

        this.stopLoading();

        // If we have zero recipes, show the no recipes message
        if (this.totalCount === 0) {
          this.noRecipesEl.classList.remove("hidden");
        } else {
          this.noRecipesEl.classList.add("hidden");
          this.renderResults(response.data.recipes);
        }

        if (this.recipes.length >= this.totalCount) {
          this.loadMoreButton.style.display = "none";
        } else {
          this.loadMoreButton.style.display = "block";
        }
      })
      .catch((e) => {
        this.stopLoading();
      });
  }

  stopLoading() {
    this.loaderEl.classList.remove("sf-loader--loading");
  }

  renderResults(results) {
    if (this.start === 0) {
      this.recipesContainerEl.innerHTML = "";
    }

    this.recipeCardEls = [];

    let i = 0;

    results.forEach((recipe) => {
      const recipeCardEl = document.createElement("div");
      recipeCardEl.classList.add(
        "col-xs-12",
        "col-sm-6",
        "col-md-4",
        "grid-item",
        "recipe-card"
      );
      const recipeThumbnailEl = document.createElement("div");
      recipeThumbnailEl.innerHTML =
        '<a class="sf-c-callout" href=" ' +
        recipe.link +
        '"><img class="img-responsive" src="' +
        recipe.thumbnail +
        '" alt="' +
        recipe.title +
        '">' +
        '<div class="callout-marker"><p class="recipie-item-title">' +
        recipe.title +
        "</p></div></a>";

      recipeCardEl.appendChild(recipeThumbnailEl);

      this.recipesContainerEl.appendChild(recipeCardEl);
      this.recipeCardEls.push(recipeCardEl);
      window.getComputedStyle(recipeCardEl).opacity;

      recipeCardEl.classList.add("recipe-card--loaded", "recipe-card--" + i);

      i++;
    });
  }

  setBannerHeight() {
    if (this.newBanner) {
      this.bannerEl.style.height = this.newBanner.offsetHeight + "px";
    } else {
      this.bannerEl.style.height = this.currentBanner.offsetHeight + "px";
    }
  }

  renderBanner() {
    this.backgroundVideo = null;
    let hasVideo = false;
    let videoEl = null;

    this.newBanner = document.createElement("div");
    this.newBanner.classList.add("recipes-banner__banner");

    const newBannerFg = document.createElement("div");
    const newBannerBg = document.createElement("div");

    newBannerFg.classList.add("recipes-banner__fg");
    newBannerBg.classList.add("recipes-banner__bg");

    const newBannerSubtitle = document.createElement("h5");
    const newBannerTitle = document.createElement("h1");
    newBannerTitle.classList.add('headline');

    newBannerTitle.innerHTML = this.bannerData.title;
    newBannerSubtitle.innerHTML = this.bannerData.subtitle;

    newBannerBg.style.backgroundImage = "url(" + this.bannerData.image + ")";

    newBannerFg.appendChild(newBannerSubtitle);
    newBannerFg.appendChild(newBannerTitle);

    // Handle Video
    if (this.bannerData.video) {
      hasVideo = true;
      const videoContainerEl = document.createElement("div");
      videoEl = document.createElement("video");
      const videoSourceEl = document.createElement("source");

      //videoEl.loop = false
      videoEl.autoplay = true;
      videoEl.muted = true;
      videoEl.playsinline = true;
      videoEl.setAttribute("muted", "true");
      videoEl.setAttribute("playsinline", "true");
      videoEl.setAttribute("webkit-playsinline", "true");

      videoSourceEl.src = this.bannerData.video;
      videoSourceEl.type = "video/mp4";

      videoEl.appendChild(videoSourceEl);

      videoContainerEl.classList.add("recipes-banner__video-container");
      videoEl.classList.add("sf-bg-video");

      videoContainerEl.appendChild(videoEl);
      newBannerBg.appendChild(videoContainerEl);
    }

    this.newBanner.appendChild(newBannerBg);
    this.newBanner.appendChild(newBannerFg);

    this.bannerEl.appendChild(this.newBanner);
    window.getComputedStyle(this.newBanner).opacity;

    this.setBannerHeight();

    this.newBanner.classList.add("recipes-banner__banner--show");

    if (hasVideo) {
      this.backgroundVideo = new BackgroundVideo(videoEl);

      setTimeout(() => {
        this.backgroundVideo.handleLoadedMetaData();
      }, 100);
    }

    setTimeout(() => {
      this.currentBanner.remove();

      this.currentBanner = this.newBanner;
    }, this.newBannerFadeInDuration);
  }

  toggleFilter(termId, initLoad = false) {
    this.start = 0;
    this.page = 1;

    if (this.ctaContainer) {
      this.ctaContainer.style.display = "none";
    }

    const filterIndex = this.filters.findIndex(
      (filter) => filter.termId === termId
    );
    this.filters[filterIndex].el.classList.add("active-recipe");

    if (this.filters[filterIndex].selected) {
      this.deselectFilter(termId);
    } else {
      this.filters[filterIndex].selected = true;

      // If this is not a Chicken Cut Filter, deselect all other filters from this filter collection
      if (this.filters[filterIndex].taxonomy !== "cut_of_chicken") {
        const filtersToDeselect = this.filtersByTaxonomy(
          this.filters[filterIndex].taxonomy
        );

        filtersToDeselect.forEach((filter) => {
          if (filter.termId !== termId) {
            this.deselectFilter(filter.termId);
          }
        });
      }
    }

    this.renderActiveFilters();

    // If it is not the inital load, get the newly matching recipes and update the URL.
    if ( !initLoad ) {
      this.getRecipes();
      this.updateUrl();
      // Trigger GA event and note if we are adding or removing
      const action = this.filters[filterIndex].selected ? "added" : "removed";
      analytics.track.client("recipe_filter", { event_category: "recipe_filter_" + action, filter_category: this.filters[filterIndex].taxonomy, filter_value: this.filters[filterIndex].label }, ["googleAnalytics"]);
    }
  }

  filtersByTaxonomy(taxonomy) {
    return this.filters.filter((filter) => filter.taxonomy === taxonomy);
  }

  deselectFilter(termId) {
    const filterIndex = this.filters.findIndex(
      (filter) => filter.termId === termId
    );
    const activeFilterIndex = this.activeFilterTags.findIndex(
      (activeFilterTag) => activeFilterTag.termId === termId
    );

    this.filters[filterIndex].selected = false;

    if (activeFilterIndex >= 0) {
      this.activeFilterTags[activeFilterIndex].el.remove();
      this.activeFilterTags.splice(activeFilterIndex, 1);
    }

    // Also uncheck input
    this.filters[filterIndex].el.checked = 0;
    this.filters[filterIndex].el.classList.remove("active-recipe");
  }

  renderActiveFilters() {
    const activeFilters = this.filters.filter((filter) => filter.selected);

    activeFilters.forEach((activeFilter) => {
      const filterIndex = this.activeFilterTags.findIndex(
        (activeFilterTag) => activeFilterTag.termId === activeFilter.termId
      );

      if (filterIndex < 0) {
        const activeFilterEl = document.createElement("div");
        const activeFilterLabelEl = document.createElement("div");
        const activeFilterTaxonomyLabelEl = document.createElement("div");

        activeFilterEl.classList.add("filter-tags__tag");
        activeFilterLabelEl.classList.add("filter-tags__label");
        activeFilterTaxonomyLabelEl.classList.add(
          "filter-tags__taxonomy-label"
        );

        activeFilterTaxonomyLabelEl.innerHTML =
          activeFilter.taxonomyLabel + ":";
        activeFilterLabelEl.innerHTML = activeFilter.label + "&nbsp x";

        activeFilterEl.appendChild(activeFilterTaxonomyLabelEl);
        activeFilterEl.appendChild(activeFilterLabelEl);

        this.recipeActiveFiltersEl.appendChild(activeFilterEl);

        activeFilterEl.addEventListener("click", () => {
          this.toggleFilter(activeFilter.termId);
        });

        this.activeFilterTags.push({
          el: activeFilterEl,
          termId: activeFilter.termId,
        });
      }
    });
  }

    // Show or hide the advanced filters
    toggleAdvancedFilters(e) {
        e.preventDefault();
        // Load the specific DOM elements, not a huge fan of querying the DOM here, but it works
        const advancedFilters = document.querySelector("div.advanced-filters");
        const advancedFilterToogleArrow = this.advancedFilterToggle.querySelector("i.arrow");

        // If the advanced filters are open, close them and switch the toggle's arrow to down
        if ( advancedFilters.classList.contains("open") ) {
            advancedFilters.classList.remove("open");
            advancedFilterToogleArrow.classList.remove("up");
            advancedFilterToogleArrow.classList.add("down");
        } else {
            advancedFilters.classList.add("open");
            advancedFilterToogleArrow.classList.remove("down");
            advancedFilterToogleArrow.classList.add("up");
        }
    }
}